/**
 * Intent-based warmup for `React.lazy` route chunks — safe to call on every hover/focus (browser dedupes the module fetch).
 */

export function warmupAdminHome() {
  void import("@/pages/admin/AdminHomePage");
}

export function warmupAdminLeads() {
  void import("@/pages/admin/SalesPipelinePage");
}

export function warmupAdminClients() {
  void import("@/pages/admin/ClientsOrganizationsPage");
}

export function warmupCreateOrganization() {
  void import("@/pages/admin/CreateOrganizationPage");
}

/** `/org` for org admins / contributors (dashboard variant resolved at runtime). */
export function warmupOrgadminDashboard() {
  void import("@/pages/org/OrgadminDashboardPage");
}

export function warmupManagerDashboard() {
  void import("@/pages/org/ManagerDashboardPage");
}

/** `/org` for team-member employees only. */
export function warmupOrgEmployeeHome() {
  void import("@/pages/org/OrgEmployeeHomePage");
}

export function warmupEmployeePortal() {
  void import("@/pages/my/EmployeePortalPage");
}

export function warmupOrgAssessmentEntry() {
  void import("@/pages/org/OrgAssessmentEntryPage");
}

export function warmupEmployeeMaps() {
  void import("@/pages/EmployeeMapsPage");
}

export function warmupMapsOverview() {
  void import("@/pages/MapsOverviewPage");
}

export function warmupOrgStudio() {
  void import("@/pages/org/OrgStudioPage");
}

export function warmupEmployeeList() {
  void import("@/pages/org/EmployeeListPage");
}

export function warmupCreateUser() {
  void import("@/pages/admin/CreateUserPage");
}

export function warmupOrganizationDetail() {
  void import("@/pages/admin/OrganizationDetailPage");
}

export function warmupStudioBundles() {
  void import("@/pages/studio/BundleListPage");
}

export function warmupStudioVideos() {
  void import("@/pages/studio/VideoLibraryPage");
}

export function warmupStudioTemplates() {
  void import("@/pages/studio/TemplateLibraryPage");
}

export function warmupStudioExercises() {
  void import("@/pages/studio/ExerciseLibraryPage");
}

export function warmupLazyStudioHref(href: string) {
  if (href.startsWith("/studio/bundles")) warmupStudioBundles();
  else if (href.startsWith("/studio/videos")) warmupStudioVideos();
  else if (href.startsWith("/studio/templates")) warmupStudioTemplates();
  else if (href.startsWith("/studio/exercises")) warmupStudioExercises();
  else if (href === "/studio/self-care") void import("@/pages/studio/SelfCareListPage");
  else if (href.startsWith("/studio/self-care/")) void import("@/pages/studio/SelfCareEditorPage");
}

/** Hover/focus: warm the matching chunk without blocking navigation. */
export function lazyIntentHandlers(warmup: () => void) {
  return {
    onPointerEnter: () => {
      warmup();
    },
    onFocus: () => {
      warmup();
    },
  } as const;
}

export function warmupGenericOrgLanding() {
  warmupOrgadminDashboard();
  warmupManagerDashboard();
  warmupOrgEmployeeHome();
}
